/**
 *    App - Text replace
 *     Text replace 'visitberlin' (case-insensitive)
 *     with '<span class="text-oblique">visitBerlin</span>'
 */

(function ($) {
  Drupal.behaviors.appTextReplace = {
    attach() {
      // case-insensitive 'contains' selector
      $.extend($.expr[':'], {
        containsNC(elem, i, match) {
          return (elem.textContent || elem.innerText || '').toLowerCase().indexOf((match[3] || '').toLowerCase()) >= 0;
        },
      });

      // oblique visitBerlin text
      const term = 'visitBerlin';
      $(`a:containsNC(${term}):not([href*="mailto:"]), h1:containsNC(${term}), h2:containsNC(${term}), h3:containsNC(${term}), p:containsNC(${term}), strong:containsNC(${term}), span:containsNC(${term}), .tooltip:containsNC(${term})`).contents().filter(function () {
        // filter only text nodes, no html or comment nodes
        return this.nodeType === 3;
      }).each(function () {
        const regex = new RegExp(`(${term})`, 'gi');
        $(this).replaceWith(this.textContent.replace(regex, '<span class="text-oblique">$1</span>'));
      });
    },
  };
}(jQuery));
